import { useEffect, useState } from "react";
import { Secretaria } from "../../types/secretaria/Secretaria";
import { useSnackbar } from "notistack";

import { useGetSecretariasQuery } from "../secretaria/SecretariaApiSlice";


type Props = {
    inputValue: string;
    handleSetLoad: (newValue: boolean) => void;
};




const useSecretariaFetch = (
    { inputValue,
        handleSetLoad
    }: Props) => {


    const [options, setOptions] = useState<Secretaria[]>([]);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();



    if (handleSetLoad) { handleSetLoad(true); }
    const { data, isFetching, error } = useGetSecretariasQuery(inputValue);

    useEffect(() => {

        if (data) {
            setOptions(data);
        }

        if (error) {
            let msgBox: string = ""
            if ('status' in error) {
                if (error.status == 'FETCH_ERROR') {
                    msgBox += 'Erro de conexão ao solicitar o serviço! Verifique sua internet. FETCH_ERROR '
                } else {
                    msgBox += 'Erro ao buscar os dados:  ' + (error.status)
                }
            } else {
                msgBox += 'Erro encontrado:' + error
            }
            enqueueSnackbar(msgBox, { variant: "error" });
        }

    }, [isFetching, error])

    if (handleSetLoad) { handleSetLoad(false); }

    return { options };
};


export default useSecretariaFetch;